// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stock-list {
  padding: 0.24rem 0.32rem;
}
.stock-card {
  position: relative;
}
.stock-card .stock-card-bg {
  width: 100%;
  position: absolute;
  top: 0;
  max-height: 2.4rem;
  overflow: hidden;
}
.stock-card .stock-box {
  position: relative;
  padding: 0.08rem 0.32rem;
  min-height: 2.4rem;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.stock-card .stock-box::before {
  content: "";
  position: absolute;
  height: 50%;
  bottom: 0;
  left: 0;
  right: 0;
  border-radius: 0.24rem;
  border: 0.02rem solid #F53207;
  border-top: 0;
  border-radius: 0 0 0.16rem 0.16rem;
  background-color: #fff;
  background-image: linear-gradient(0deg, rgba(245, 50, 7, 0) 0%, rgba(255, 210, 199, 0.1) 100%);
  color: var(--text-color);
}
.stock-card .stock-box .stock-name {
  position: relative;
  margin-top: 0.32rem;
  color: #333;
  font-feature-settings: 'liga' off, 'clig' off;
  font-size: 0.28rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.stock-card .stock-box .stock-name .stock-name-text {
  width: calc(100% - 1.6rem);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.stock-card .stock-box .stock-code {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.08rem;
  color: #666;
  font-feature-settings: 'liga' off, 'clig' off;
  font-size: 0.32rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.stock-card .stock-box .stock-code .stock-code-text {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.stock-card .stock-box .stock-code .stock-changes {
  text-align: right;
  font-size: 0.36rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.stock-card .stock-box .stock-code .stock-changes.stock-red {
  color: #F24822;
}
.stock-card .stock-box .stock-code .stock-changes.stock-green {
  color: #00A98E;
}
.stock-card .stock-box .stock-code .stock-changes.stock-gray {
  color: #999;
}
.stock-card .stock-box .stock-footer {
  position: relative;
  margin-top: auto;
  padding: 0.16rem 0;
}
.stock-card .stock-box .stock-footer .stock-description {
  color: #666;
  font-feature-settings: 'liga' off, 'clig' off;
  font-size: 0.28rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.stock-card .stock-box .stock-footer .stock-recommendReason {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  box-sizing: content-box;
  line-height: 0.4rem;
  word-break: break-all;
}
.stock-card .stock-box .stock-footer .stock-recommend {
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  gap: 0.16rem;
  font-size: 0.28rem;
  color: rgba(0, 0, 0, 0.85);
}
.stock-card .stock-box .stock-footer .stock-recommend .stock-recommend-text {
  white-space: nowrap;
}
.stock-card .stock-box .stock-footer .stock-recommend .stock-recommend-tag {
  padding: 0.08rem 0.12rem;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  background-color: rgba(242, 72, 34, 0.2);
  border-radius: 0.4rem;
  color: #F24822;
  font-size: 0.24rem;
  white-space: nowrap;
  text-decoration: underline;
}
.stock-card .stock-box .stock-footer .stock-recommend .stock-recommend-tag .stock-recommend-tag-icon {
  width: 0.24rem;
  height: 0.24rem;
}
.stock-card .stock-box .stock-footer .stock-recommend .stock-recommend-tag .stock-recomend-tag-text {
  margin-left: 0.1rem;
}
.stock-card .stock-card--view {
  position: absolute;
  top: 0.2rem;
  right: 0.36rem;
  color: #fff;
  font-size: 0.24rem;
  text-align: center;
}
.stock-card + .stock-card {
  margin-bottom: 0.24rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/marketing/components/stock-card/index.less"],"names":[],"mappings":"AAAA;EACE,wBAAA;AACF;AAEA;EACE,kBAAA;AAAF;AADA;EAII,WAAA;EACA,kBAAA;EACA,MAAA;EACA,kBAAA;EACA,gBAAA;AAAJ;AARA;EAYI,kBAAA;EACA,wBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;AADJ;AAGI;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,sBAAA;EACA,6BAAA;EACA,aAAA;EACA,kCAAA;EACA,sBAAA;EACA,8FAAA;EACA,wBAAA;AADN;AA/BA;EAoCM,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,6CAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAFN;AAzCA;EA8CQ,0BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAFR;AA/CA;EAsDM,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,6CAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAJN;AA7DA;EAoEQ,OAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAJR;AAnEA;EA2EQ,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AALR;AAOQ;EACE,cAAA;AALV;AAQQ;EACE,cAAA;AANV;AASQ;EACE,WAAA;AAPV;AAnFA;EAgGM,kBAAA;EACA,gBAAA;EACA,kBAAA;AAVN;AAxFA;EAqGQ,WAAA;EACA,6CAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,aAAA;EACA,qBAAA;EACA,4BAAA;AAVR;AAtGA;EAoHQ,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;AAXR;AAhHA;EA+HQ,kBAAA;EAEA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,2BAAA;EACA,YAAA;EACA,kBAAA;EACA,0BAAA;AAbR;AA3HA;EAuJU,mBAAA;AAzBV;AA9HA;EA2JU,wBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,wCAAA;EACA,qBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,0BAAA;AA1BV;AA3IA;EAwKY,cAAA;EACA,eAAA;AA1BZ;AA/IA;EA6KY,mBAAA;AA3BZ;AAlJA;EAqLI,kBAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;AAhCJ;AAoCA;EACE,sBAAA;AAlCF","sourcesContent":[".stock-list {\n  padding: 12px 16px;\n}\n\n.stock-card {\n  position: relative;\n\n  .stock-card-bg {\n    width: 100%;\n    position: absolute;\n    top: 0;\n    max-height: 120px;\n    overflow: hidden;\n  }\n\n  .stock-box {\n    position: relative;\n    padding: 4px 16px;\n    min-height: 120px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      height: 50%;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      border-radius: 12px;\n      border: 1px solid #F53207;\n      border-top: 0;\n      border-radius: 0 0 8px 8px;\n      background-color: #fff;\n      background-image: linear-gradient(0deg, rgba(245, 50, 7, 0) 0%,  rgba(255, 210, 199, .1) 100%);\n      color: var(--text-color);\n    }\n\n    .stock-name {\n      position: relative;\n      margin-top: 16px;\n      color: #333;\n      font-feature-settings: 'liga' off, 'clig' off;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: normal;\n\n      .stock-name-text {\n        width: calc(100% - 80px);\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n    }\n\n    .stock-code {\n      position: relative;\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      align-items: center;\n      margin-top: 4px;\n      color: #666;\n      font-feature-settings: 'liga' off, 'clig' off;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: normal;\n\n      .stock-code-text {\n        flex: 1;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n\n      .stock-changes {\n        text-align: right;\n        font-size: 18px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: normal;\n\n        &.stock-red {\n          color: #F24822;\n        }\n\n        &.stock-green {\n          color: #00A98E;\n        }\n\n        &.stock-gray {\n          color: #999;\n        }\n      }\n    }\n\n    .stock-footer {\n      position: relative;\n      margin-top: auto;\n      padding: 8px 0;\n\n      .stock-description {\n        color: #666;\n        font-feature-settings: 'liga' off, 'clig' off;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: normal;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        display: -webkit-box;\n        line-clamp: 2;\n        -webkit-line-clamp: 2;\n        -webkit-box-orient: vertical;\n      }\n\n      .stock-recommendReason {\n        overflow: hidden;\n        text-overflow: ellipsis;\n        display: -webkit-box;\n        -webkit-line-clamp: 2;\n        -webkit-box-orient: vertical;\n        box-sizing: content-box;\n        line-height: 20px;\n        word-break: break-all;\n      }\n\n      .stock-recommend {\n        position: relative;\n        // padding: 4px 16px;\n        display: flex;\n        flex-direction: row;\n        flex-wrap: wrap;\n        align-items: center;\n        justify-content: flex-start;\n        gap: 8px;\n        font-size: 14px;\n        color: rgba(0, 0, 0, .85);\n\n        // &::after {\n        //   content: \"\";\n        //   position: absolute;\n        //   top: 0;\n        //   right: -4px;\n        //   bottom: 0;\n        //   width: 20px;\n        //   border-bottom-right-radius: 12px;\n        //   z-index: 2;\n        //   background-image: linear-gradient(90deg,rgba(255,255,255,0),rgba(255,255,255,1) 90%,rgba(255,255,255,1) 100%)\n        // }\n\n        .stock-recommend-text {\n          white-space: nowrap;\n        }\n\n        .stock-recommend-tag {\n          padding: 4px 6px;\n          display: flex;\n          flex-direction: row;\n          flex-wrap: wrap;\n          align-items: center;\n          background-color: rgba(242, 72, 34, .2);\n          border-radius: 20px;\n          color: #F24822;\n          font-size: 12px;\n          white-space: nowrap;\n          text-decoration: underline;\n\n          .stock-recommend-tag-icon {\n            width: 12px;\n            height: 12px;\n          }\n\n          .stock-recomend-tag-text {\n            margin-left: 5px;\n          }\n        }\n      }\n    }\n  }\n\n  .stock-card--view {\n    position: absolute;\n    top: 10px;\n    right: 18px;\n    color: #fff;\n    font-size: 12px;\n    text-align: center;\n  }\n}\n\n.stock-card + .stock-card {\n  margin-bottom: 12px;\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
